// Aetna 固定列表 + 上限，照抄 V2 原型（credentialing tab.html AETNA_FOCUS_AREAS）。
// 'Substance Use Disorders' 不在 Aetna 原始清单里，按产品要求保留并参与默认预选。
export const AETNA_FOCUS_MAX = 8;

export const AETNA_FOCUS_AREAS = [
    'Anxiety Disorders',
    'Attention Deficit Disorder',
    'Mood Disorders',
    'Obsessive-Compulsive Disorder',
    'Post-Traumatic Stress Disorder',
    'Psychotic Disorders',
    'Autism',
    'Eating Disorders',
    'Personality Disorders',
    'Learning Disabilities',
    'Co morbidity',
    'HIV / AIDS',
    'Health-Disabilities',
    'Pain Management',
    'Adolescent Psychiatry',
    'Child Psychiatry',
    'Geriatric Psychiatry',
    'Psychiatry, Autism Spectrum',
    'Psychiatry, Child and Adolescent, Autism Spectrum',
    'Addiction Psychiatry',
    'Addiction Specialist',
    'Detoxification',
    'MAT (Medication-Assisted Treatment)',
    'Medication-Assisted Treatment - Opioid Use',
    'Office-Based Opioid Treatment (OBOT)',
    'SAP (Substance Abuse Professional)',
    'Pharmacology / Medication Management',
    'Cognitive Behavioral Therapy',
    'Dialectical Behavioral Therapy',
    'EMDR (Eye Movement Desensitization and Reprocessing)',
    'Group Therapy',
    'Marriage and Family Therapy',
    'In-Home Therapy',
    'Codependency Behavioral Therapy',
    'Art Therapy',
    'Biofeedback',
    'Hypnotherapy',
    'Bereavement / Grief Counseling',
    'Child Abuse',
    'Christian Counseling',
    'Crisis Intervention',
    'Domestic Violence',
    'Gay-Lesbian Issues',
    'Gender Identity',
    'LGBTQ+ Counseling',
    'Life Management Counseling',
    "Men's Issues",
    'Parenting Issues',
    'Sexual / Physical Abuse',
    'Stress Management',
    'Transgender Care',
    "Women's Issues",
    'Certified Employee Assistance Professional',
    'Managed Disability',
    'Neuropsychological Testing',
    'Psychological Testing',
    'Substance Use Disorders',
];

// 首次进入 Aetna Focus 步骤时的默认预选（原型 AETNA_FOCUS_DEFAULT，恰好 8 项）
export const AETNA_FOCUS_DEFAULT = [
    'Anxiety Disorders',
    'Mood Disorders',
    'Attention Deficit Disorder',
    'Post-Traumatic Stress Disorder',
    'Substance Use Disorders',
    'Psychotic Disorders',
    'Obsessive-Compulsive Disorder',
    'Personality Disorders',
];
